export default __webpack_public_path__ + "static/media/portfolio.dde46783.png";